import { useEffect, useState } from "react";
import WhatsAppButton from "../../../Components/CluppForms/WhatsappButton";
import checkIfIsInsideBussinessHours from "../../../utils/insideBussinessHours";
import { Box, Typography } from "@mui/material";
import sadClupp from "../../../Assets/Clupp_Triste.png";

const ErrorPause = ({ state, setState, field }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isInsideBusinessHours, setIsInsideBusinessHours] = useState(false);

  useEffect(() => {
    const fetchBusinessHours = async () => {
      const { isInsideBusinessHours } = await checkIfIsInsideBussinessHours(
        "Customer support"
      );
      setIsInsideBusinessHours(isInsideBusinessHours);

      const message = isInsideBusinessHours
        ? "Estamos en horario de atención. Da clic en 'Notificar problema' para que puedas ponerte en contacto con un agente por WhatsApp."
        : "Actualmente estamos fuera del horario de atención. Nos pondremos en contacto contigo tan pronto como podamos.";

      setErrorMessage(message);
    };

    fetchBusinessHours();
  }, []);

  return (
    <Box textAlign="center" width="100%" padding={0}>
      <img
        src={sadClupp}
        alt="Cluppcito Happy"
        style={{ width: 150, height: 170, marginBottom: 3 }}
      />
      <Typography variant="h6" gutterBottom>
        ¡Oops! Algo salió mal
      </Typography>
      <Typography variant="body1">
        {`${errorMessage}`}
      </Typography>
      {isInsideBusinessHours && (
        <WhatsAppButton
          title={"Notificar problema"}
          link={
            "https://wa.me/5215577460177?text=Hola,%20acept%C3%A9%20el%20descuento%20del%20proceso%20de%20cancelaci%C3%B3n%2C%20pero%20no%20se%20pudo%20aplicar.%20%C2%BFPodr%C3%ADan%20ayudarme%3F"
          }
        />
      )}
    </Box>
  );
};

export default ErrorPause;
